import React from 'react';

import CssClassesTagsInput
  from 'zoomforth_codesbane_editor/exterior_editor/sidebar/shared/css_classes_tagsinput_container.jsx';

const TOOLTIP_MSG = `
  CSS classes allow you to style this subpage via site scoped CSS or custom CSS
  in the theme.
`;

const SubpageCssClassesInput = (props)=>
  <CssClassesTagsInput tooltip={TOOLTIP_MSG} {...props} />;

export default SubpageCssClassesInput;
